import type { AppShellBanner } from "../../../../../../shared/frontend/layout/AppShell";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/useAuth";
import { Permissions } from "../constants/permissions";
import { useGlobalStudioContext } from "./useGlobalStudioContext";

/**
 * Hinweis und roter Rahmen für gesperrte Standorte (reduzierte Standortanzahl im Tarif). Der Hinweis
 * erscheint, sobald ein Studio der aktuellen Auswahl gesperrt ist; gerahmt wird der Arbeitsbereich,
 * wenn ausdrücklich ein gesperrtes Studio gewählt ist oder alle Studios gesperrt sind.
 */
export function useStudioLockBanner(tr: (key: string) => string): { banner?: AppShellBanner; framed: boolean } {
  const auth = useAuth();
  const navigate = useNavigate();
  const { allowedStudios, effectiveStudioIds, isAllStudios, selectedStudioIds } = useGlobalStudioContext();
  const inScope = allowedStudios.filter((studio) => effectiveStudioIds.includes(studio.id));
  const locked = inScope.filter((studio) => studio.billingLockedAt);
  if (locked.length === 0) return { framed: false };

  const framed = isAllStudios
    ? locked.length === inScope.length
    : locked.some((studio) => selectedStudioIds.includes(studio.id));
  const canOpenBilling = auth.hasPermission(Permissions.BillingRead) || auth.hasPermission(Permissions.BillingWrite);
  return {
    framed,
    banner: {
      type: "error",
      message: tr("Locked in plan: {names}").replace("{names}", locked.map((studio) => studio.name).join(", ")),
      description: tr("No check-in, no payments, no new contracts and no changes to members and contracts of these locations. Data remains readable."),
      action: canOpenBilling ? { label: tr("to the plan page"), onClick: () => navigate("/billing?changePlan=1") } : undefined,
    },
  };
}
